<template>
<!-- eslint-disable max-len -->
<div
  :class="{ 'decision-form': true, native: (native), sf: (starfighter) }"
  :style="{
    width: decision.decisionContainerWidthOverride ? decision.decisionContainerWidthOverride : undefined,
    'max-height': decision.decisionContainerMaxHeightOverride ? decision.decisionContainerMaxHeightOverride : undefined,
    'min-height':
      (decision.decisionContainerMaxHeightOverride
        ? `min(77.8%, ${decision.decisionContainerMaxHeightOverride})`
        : undefined),
  }"
>
  <h1 v-if="!(decision.hideTitle)" class="form-header" style="width: 100%; margin: 0;" v-html="decision.displayTitle || decision.title"></h1>
  <div v-if="!(decision.hideTitle) || decision.description" class="description-bar">
    <div class="description" v-html="decision.description">
    </div>
  </div>
  <div :class="{ native, sf: (starfighter) }" class="decision-form-form" @input="onFormInput">
    <div
      v-for="(entry, i) in decision.formEntries"
      :key="i"
    >
      <template v-if="!(entry.displayConditionally) || checkDisplayCondition(i)">
        <div
          v-if="entry.type === 'employmentStartDate'"
          style="margin: 18px 0;"
        >
          <div
            style="font-size: 1.18rem; margin: 0 0 4px;"
            v-html="entry.prompt"
          ></div>
          <div
            style="display: flex; flex-flow: row wrap; align-items: center; font-size: 1.05rem;"
          >
            <select-input
              v-if="!(choices[i].applicant) || entry.removeNoDateCheckbox"
              v-model="choices[i].month"
              label-html
              :options="getMonthOptions(entry)"
              :use="isUsingMonthOptionObjects(entry) ? 'v' : undefined"
              :display="isUsingMonthOptionObjects(entry) ? 't' : undefined"
              disable-sort
              style="flex-basis: 30%; flex-grow: 1; min-width: 150px; max-width: 175px; margin: 0 16px 0 0;"
              :placeholder="entry.overridePlaceholder ? entry.monthPlaceholder : undefined"
            >{{ entry.overridePlaceholder ? entry.monthLabel : 'Month' }}</select-input>
            <select-input
              v-if="(!(choices[i].applicant) || entry.removeNoDateCheckbox) && entry.requestDay"
              v-model="choices[i].day"
              label-html
              :options="[
                1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31
              ]"
              disable-sort
              style="flex-basis: 9%; flex-grow: 1; min-width: 40px; max-width: 70px; margin: 0 16px 0 0;"
              integer
              :placeholder="entry.overridePlaceholder ? entry.dayPlaceholder : undefined"
            >{{ entry.overridePlaceholder ? entry.dayLabel : 'Day' }}</select-input>
            <select-input
              v-if="!(choices[i].applicant) || entry.removeNoDateCheckbox"
              v-model="choices[i].year"
              label-html
              :options="getYearOptions(entry)"
              disable-sort
              style="flex-basis: 30%; flex-grow: 1; min-width: 110px; max-width: 120px; margin: 0 16px 0 0;"
              integer
              :placeholder="entry.overridePlaceholder ? entry.yearPlaceholder : undefined"
            >{{ entry.overridePlaceholder ? entry.yearLabel : 'Year' }}</select-input>
            <checkbox-input
              v-if="!(entry.removeNoDateCheckbox)"
              v-model="choices[i].applicant"
              style="margin: 10px 0 0 5px;"
            >{{ entry.noDateCheckboxText ? entry.noDateCheckboxText : 'I haven\'t started role' }}</checkbox-input>
          </div>
        </div>
        <div
          v-else-if="entry.type === 'year'"
          style="margin: 18px 0; font-size: 1.18rem;"
        >
          <select-input
            v-model="choices[i]"
            label-html
            :options="getYearOptions(entry)"
            disable-sort
            :placeholder="entry.overridePlaceholder ? entry.placeholder : 'Select one...'"
            integer
          >{{entry.prompt}}</select-input>
        </div>
        <div
          v-else-if="entry.type === 'range'"
          style="margin: 18px 0; font-size: 1.18rem;"
        >
          <select-input
            v-model="choices[i]"
            label-html
            :options="getRangeOptions(entry)"
            disable-sort
            :placeholder="entry.overridePlaceholder ? entry.placeholder : 'Select one...'"
            integer
          >{{entry.prompt}}</select-input>
        </div>
        <div
          v-else-if="entry.type === 'freeResponse'"
          style="margin: 18px 0; font-size: 1.18rem;"
        >
          <div
            :style="{
              width: '100%',
              display: 'flex',
              'flex-direction': 'row',
              'justify-content': 'space-between',
              'align-items': 'flex-end',
            }"
          >
            <div
              :style="{
                display: 'flex',
                'flex-direction': 'row',
                'justify-content': 'flex-start',
                'align-items': 'flex-end',
              }"
            >
              <div v-html="entry.prompt">
              </div>
              <div
                v-if="entry.responseMaximumLength"
                style="font-size: 70%;"
              >&nbsp;&nbsp;&nbsp;({{choices[i].length}} / {{entry.responseMaximumLength}})</div>
            </div>
            <div v-if="entry.responseMinimumLength" style="font-size: 70%; text-align: right;">
              <div
                v-html="
                  entry.lengthRequirementTextOverride
                  ? entry.lengthRequirementTextOverride
                  : `(At least ${entry.responseMinimumLength} characters required)`
                "
              ></div>
            </div>
          </div>
          <text-input
            v-model="choices[i]"
            no-count
            @focus="onFocus"
            @blur="onBlur"
          >{{ entry.overridePlaceholder ? entry.placeholder : entry.prompt }}</text-input>
        </div>
        <div
          v-else-if="entry.type === 'selection'"
          style="margin: 18px 0; font-size: 1.18rem;"
        >
          <select-input
            v-model="choices[i]"
            label-html
            :options="entry.choices"
            options-html
            disable-sort
            use="_id"
            display="title"
            :placeholder="entry.overridePlaceholder ? entry.placeholder : 'Select one...'"
          >{{entry.prompt}}</select-input>
        </div>
      </template>
    </div>
  </div>
  <!-- {{ choices }} -->
  <div class="decision-form-controls">
    <button
      class="btn decision-form-submit"
      :disabled="!validInput"
      @click.prevent="submitForm"
      :tabindex="0"
      :style="{
        height: (decision.choiceSelectButtonHeight ? decision.choiceSelectButtonHeight : undefined),
        width: (decision.choiceSelectButtonWidth ? decision.choiceSelectButtonWidth : undefined),
      }"
    >
      <div v-html="submitButtonText ? submitButtonText : 'Submit'"></div>
    </button>
  </div>
</div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions, mapMutations } from 'vuex';

import TextInput from '@/components/ui/inputs/TextInput';
import SelectInput from '../../ui/inputs/SelectInput';
import CheckboxInput from '../../ui/inputs/CheckboxInput';

export default {
  props: {
    decision: { type: Object },
    colors: { type: Array },
    selectedChoices: { type: Array },
    hasSubmitted: { type: Boolean },
    submitButtonText: { type: String },
  },
  components: {
    SelectInput,
    CheckboxInput,
    TextInput,
  },
  data() {
    return {
      choices: this.decision.formEntries.map(this.initializeChoice),
      formDisablesForcedLandscape: true,
    };
  },
  computed: {
    ...mapGetters([
      'roles',
      'allPlayers',
      'cash',
      'playerDecision',
      'playerGroupRole',
      'game',
      'starfighter',
      'native'
    ]),
    defaultYearOptions() {
      const res = [];
      for (let i = 0; i < 24; ++i) {
        res[i] = (new Date()).getUTCFullYear() - i;
      }
      return res;
    },
    validInput() {
      return (this.choices.length === this.decision.formEntries.length)
        && this.decision.formEntries.every((entry, i) => {
          if (this.checkDisplayCondition(i)) {
            if (entry.type === 'employmentStartDate') {
              return (this.choices[i].applicant && !(entry.removeNoDateCheckbox))
                || (this.choices[i].month && this.choices[i].year && (!(entry.requestDay) || this.choices[i].day));
            }
            if (entry.type === 'freeResponse') {
              return (this.choices[i]
                && (!(entry.responseMinimumLength) || this.choices[i].length >= entry.responseMinimumLength)
                && (!(entry.responseMaximumLength) || this.choices[i].length <= entry.responseMaximumLength));
            }
            return this.choices[i];
          }
          return true;
        });
    },
  },
  methods: {
    ...mapMutations([
      'setDisableForcedLandscape',
    ]),
    ...mapActions([
      'playSound',
      'stopSounds',
    ]),
    async playClick() {
      await Vue.nextTick();
      this.playSound({
        sound:
          this.decision.choiceSelectButtonSound
          || this.game.clickSoundOverride
          || this.resolveAssetPath('click_cut.mp3', 'ui/customer'),
        soundIsUnstoppable: true,
      });
    },
    async playChoiceInput() {
      const sound = (this.choiceDisplayType === 'carousel' && !(this.decision.choiceInputChangeSound))
        ? this.game.arrowButtonSound
        : this.decision.choiceInputChangeSound;
      if (sound) {
        await Vue.nextTick();
        this.playSound({
          sound,
          soundIsUnstoppable: true,
        });
      }
    },
    // TODO: choice input off currently not supported... employment date start checkbox would be the only relevant thing for this
    async playChoiceInputOff() {
      if (this.decision.choiceInputOffSound || this.decision.choiceInputChangeSound) {
        await Vue.nextTick();
        this.playSound({
          sound: (this.decision.choiceInputOffSound || this.decision.choiceInputChangeSound),
          soundIsUnstoppable: true,
        });
      }
    },
    onFocus() {
      if (!(this.formDisablesForcedLandscape)) {
        this.setDisableForcedLandscape(true);
      }
    },
    onBlur() {
      if (!(this.formDisablesForcedLandscape)) {
        this.setDisableForcedLandscape(false);
      }
    },
    onFormInput(ev) {
      if (!(ev.inputType === 'insertText')) { // suppress input change sound for free response entries
        this.playChoiceInput();
      }
    },
    async submitForm() {
      await this.playClick();
      await new Promise(resolve => setTimeout(resolve, 250));
      const { choices } = this;
      this.$emit('input', { choices });
    },
    initializeChoice({ type }) {
      if (type === 'employmentStartDate') {
        return {
          month: '',
          year: '',
          applicant: false,
        };
      } else if (type === 'freeResponse') {
        return '';
      }
      return null;
    },
    checkDisplayCondition(index) {
      const entry = this.decision.formEntries[index];
      const dependentEntryIndex = index + entry.dependentEntryOffset;
      if (dependentEntryIndex < 0
        || dependentEntryIndex > this.decision.formEntries.length) {
        return true;
      }
      const dependentEntry = this.decision.formEntries[dependentEntryIndex];
      if (!dependentEntry
        || entry.dependentChoiceIndex < 0
        || entry.dependentChoiceIndex > dependentEntry.choices.length) {
        return true;
      }
      const dependentChoice = dependentEntry.choices[entry.dependentChoiceIndex];
      if (!dependentChoice) return true;
      const shouldDisplay = dependentChoice._id === this.choices[dependentEntryIndex];
      if (!shouldDisplay) {
        this.choices[index] = this.initializeChoice(entry);
      }
      return shouldDisplay;
    },
    isUsingMonthOptionObjects(entry) {
      return entry.displayOptionsForMonths || entry.displayNumeralsForMonthOptions;
    },
    getMonthOptions(entry) {
      const monthValues = [
        'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
      ];
      if (entry.displayOptionsForMonths) {
        return entry.displayOptionsForMonths
          .split(',') // parse comma-separated list into array
          .map(o => o.trim()) // trim
          .filter(o => o) // remove blanks
          .slice(0, 12) // take first 12
          .map((o, index) => ({ t: o, v: monthValues[index % 12] })); // create option objects (mod 12 for safety)
      }
      return entry.displayNumeralsForMonthOptions
        ? [
          { t: '1', v: 'January' },
          { t: '2', v: 'February' },
          { t: '3', v: 'March' },
          { t: '4', v: 'April' },
          { t: '5', v: 'May' },
          { t: '6', v: 'June' },
          { t: '7', v: 'July' },
          { t: '8', v: 'August' },
          { t: '9', v: 'September' },
          { t: '10', v: 'October' },
          { t: '11', v: 'November' },
          { t: '12', v: 'December' },
        ]
        : monthValues;
    },
    getRangeOptions(entry) {
      const options = [];
      if (entry.startRange && entry.endRange) {
        let option = entry.startRange;
        if (entry.startRange > entry.endRange) {
          while (option >= entry.endRange) {
            options.push(option);
            option -= 1;
          }
        } else {
          while (option <= entry.endRange) {
            options.push(option);
            option += 1;
          }
        }
      }
      return options;
    },
    getYearOptions(entry) {
      if (entry.minYear) {
        const years = [];
        let year = entry.maxYear ? entry.maxYear : ((new Date()).getUTCFullYear());
        while (year >= entry.minYear) {
          years.push(year);
          year -= 1;
        }
        return years;
      }
      return this.defaultYearOptions;
    }
  },
  created() {
    if (this.hasSubmitted) {
      // eslint-disable-next-line no-restricted-syntax
      for (let i = 0; i < this.choices.length; ++i) {
        this.choices[i] = this.selectedChoices[i];
      }
    }
  },
  beforeMount() {
    if (this.formDisablesForcedLandscape) {
      this.setDisableForcedLandscape(true);
    }
  },
  mounted() {
    this.stopSounds();
  },
  beforeDestroy() {
    // make sure disable forced landscape can't get left on
    this.setDisableForcedLandscape(false);
  },
};
</script>

<style lang="scss" scoped>
.decision-form {
  position: absolute;
  width: 76.6%;
  min-height: 77.8%;
  max-height: 77.8%;
  padding: 20px;
  background-color: white;

  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
}

.decision-form.native
{
  display: flex;
  border: 25px solid rgba(0, 0, 0, 0);
  border-image: url('/static/ui/customer/B2_TextBox_90.png') 90 fill;
  transform: translateZ(0);
}

.decision-form h2 {
  display: inline-block;
  width: 380px;
  height: auto;
  margin: 0 20px 0 0;
}

.decision-form h2 img {
  width: 380px;
  height: 210px;
  margin-bottom: 15px;
  object-position: top left;
  object-fit: cover;
  border: 4px inset white;
}
.decision-form h2 article {
  height: 430px;
  padding: 15px;
}
.decision-form h2 article h1 {
  line-height: 36px;
  font-size: 32px;
  font-weight: bold;
  color: var(--primaryColor);
  overflow: auto;
  margin-bottom: 15px;
}
.decision-form h2 article p {
  line-height: 32px;
  font-size: 28px;
  font-weight: bold;
  color: black;
  overflow: auto;
}
.decision-form-description {
  overflow-y: auto;
}

.description-bar {
  margin-top: 10px;
  margin-left: -20px;

  display: flex;
  justify-content: space-between;
  padding-left: 40px;
  padding-right: 40px;
  padding-top: 10px;
  padding-bottom: 10px;
  color: white;
  width: calc(100% + 40px);
  background-color: var(--neutralColor);
}

.description {
  font-size: 1.15rem;
  width: 100%;
}

.decision-form-form {
  overflow-y: auto;
  width: 100%;
  flex-basis: 84.3%;
  flex-grow: 1;
  padding: 5px;
}

.decision-form-controls {
  width: 100%;
  padding: 8px 0 0;
  align-self: flex-end;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
}
.decision-form .btn {
  width: 250px;
  height: 80px;
  font-size: 44px;
  line-height: 44px;
}
.decision-form-submit {
  float: right;
}

.form-header {
  font-weight: bolder;
}

.character-icon
{
  background-color: white;
  outline: 1px solid black;
}
</style>



// WEBPACK FOOTER //
// src/components/game/ui/DecisionForm.vue